module.exports = {
  language: {
    name: '中文',
    code: 'zh'
  },
  user: {
    login:'登录',
    register:'注册',
    loginUsername:'请输入邮箱/手机号',
  },
  company: {
    name: '北京顺福达物流有限公司'
  },
  navgate: {
    item1: '关于我们',
    item2: '运营优势',
    item3: '公司发展',
    item4: '合作客户',
    item5: '车辆资源'
  },
  waybillQuery: {
    title: '运单查询',
    placeholder: '请输入查询的运单号',
    text1: '时效保障',
    text2: '网点查询',
    text3: '配送范围',
    text4: '物流追踪'
  },
  companyProfile: {
    title: '关于我们',
    text1: '2003年成立于北京,注册资本为1000万元',
    text2: '公司除了是经商务部批准的货运代理企业，有交通部颁发的道路运营许可证，并在海关登记注册载运海关监管货物，同时被评为道路运输百强诚信企业、城市货运保障绿色车队的称号，是国内一家极具竞争力的货代物流公司。',
    text3: '企业核心业务包括各种货物的国际代理运输、海运、空运的进出口货物的代理报关，代理报检，一般货物的国内运输、进出口贸易代理业务、进口货物的分拨、配送、堆场、仓储、保税仓储等业务及其他相关配套增值服务。',
    text4: '公司有20年的运营经验，具备成熟的运营体系、专业的操作团队和流程、健全的物流操作电子系统、国家标准排放的运输车队，结合现代化的管理手段为诸多品牌企业提供服务自公司成立之时至今。',
    text5: '本公司的业务覆盖全国，与国内外众多企业建立了长期稳定的合作关系，能够适应国内及国际的经营网络的需求，以保证对客户提供安全、快捷、可靠的服务。'
  },
  TransQualification: {
    title: '公司运营资质'
  },
  operatingAdvantages: {
    title: '运营优势',
    text1: '服务人员有较高的服务意识、丰富的操作经验、积极的服务态度',
    text2: '有官方正规资质认证，专业级物流企业，诚信物流企业、绿色车队认证等',
    text3: '拥有专业的物流人才，规范的操作流程，系统的服务程序',
    text4: '有保价运输、包装、接货、送货、签收回单等增值服务',
    text5: '货物运输过程严格保护，保证时效安全',
    text6: '有较强的运营保障系统、条形码标示、办公自动化、物流信息同步化',
  },
  managementSystem: {
    title1: '公司经营理念',
    text1: '公司秉承“共同成长，共同发展”的理念，始终坚持“以自己的优势来为客户提供最低的物流成本和最佳物流运输方案”的原则，以优质服务为中心，立足北京，辐射全国。',
    title2: '公司管理制度',
    text2: '公司自成立以来，历时20年不断摸索，不断提升本公司的运营管理，同时整合优势资源以满足高端运输定制服务的企业，让客户享受到真正高端的运输服务。',
    text_m1: '公司严格遵循KPI指标考核模式',
    text_m2: '订车及时满足需求率',
    text_m3: '提货按时按需求',
    text_m4: '货物按时精准送达客户手中',
    text_m5: '货物运输过程严格保护',
    text_m6: '做到单证一致，及时记录',
    text_m7: '各项指标均达98%以上，接受客户监督考核。'
  },
  businessTrends: {
    title: '公司发展',
    text1: '公司的业务覆盖全国，各区所占比例图',
    text2: '业务增长量比率图'
  },
  cooperativeClient: {
    title: '主要合作客户',
    items: [
      {
        name: '宝洁公司',
        dec: '项目服务地区：全国',
        year: '合作时长：19年'
      },
      {
        name: '一商美洁',
        dec: '项目服务地区：全国',
        year: '合作时长：19年'
      },
      {
        name: '沃尔沃',
        dec: '项目服务地区：西北、华中、东北、华北地区',
        year: '合作时长：7年'
      },
      {
        name: 'SMC',
        dec: '项目服务地区：西北、华中、东北、华北地区',
        year: '合作时长：5年'
      },
      {
        name: '铁力国际货运',
        dec: '项目服务地区：东北、东北、华中地区',
        year: '合作时长：9年'
      },
      {
        name: '雅科比',
        dec: '项目服务地区：西北、东北、华北地区',
        year: '合作时长：11年'
      },
      {
        name: '北京利乐',
        dec: '项目服务地区：全国',
        year: '合作时长：19年'
      }
    ]
  },
  vehicleResources: {
    title: '车辆资源',
    leftDiv: {
      text1: '高价值商业保险',
      text2: '整合资源协同车辆600',
      text3: '排放标准均国五及以上'
    },
    rightDiv: {
      text1: '20英尺、40英尺集装箱货车',
      text2: '4.2米——17.5米厢式货车',
      text3: '6.8米——17.5米冷藏车',
      text4: '7.2米——16.5米高护栏车',
      text5: '特种大件运输车辆'
    }
  },
  footerAll: {
    companyName: '北京顺福达物流有限公司',
    text1: {
      i: '联系',
      Q: '董经理'
    },
    text2: {
      i: '电话',
      Q: '13910209660'
    },
    text3: {
      i: '邮箱',
      Q: 'honggangdong@163.com'
    },
    text4: {
      i: '地址',
      Q: '北京市经开区合生世界村I区6号楼1605室'
    },
    placeholder: {
      n1: '姓名',
      n2: '电话',
      n3: '邮箱',
      n4: '留言内容'
    },
    btn: '提交',
    declare: '版权所有：北京顺福达物流有限公司'
  }
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js